import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { REGION } from '@angular/fire/compat/functions';
import {
	AccessCodeService,
	AccountStatusService,
	ConfigService,
	DrawerService,
	EmailService,
	FaqService,
	MessageService,
	MetadataService,
	MonerisService,
	OrganizationsGroupService,
	OrganizationsService,
	ParksService,
	ProfileService,
	SectorsService,
	ServicesService,
	SessionService,
	UserService,
	UserVehiclesService,
	VehiclesService
} from '@shared/core';
import { AuthService, ContractService, SubscriptionService } from '@shared/store';
import { environment } from '@spaq/configs/environment';

@NgModule({
	declarations: [],
	imports: [CommonModule],
	providers: [
		UserService,
		AccountStatusService,
		UserVehiclesService,
		SectorsService,
		MetadataService,
		SessionService,
		AccountStatusService,
		AuthService,
		FaqService,
		ConfigService,
		ProfileService,
		SubscriptionService,
		ServicesService,
		ParksService,
		OrganizationsService,
		ContractService,
		AccessCodeService,
		EmailService,
		VehiclesService,
		MonerisService,
		MessageService,
		DrawerService,
		OrganizationsGroupService,
		{ provide: REGION, useValue: environment.functionsRegion }
	]
})
export class CoreServicesModule {}
